import { createClient } from '@connectrpc/connect';
import { connectTransport } from '@mono/ui-runtime/connect';
import { RegistryContractService } from '../../../../../../../gen/ts/mono/datagateway/v1/registry_contract_connect';
import { deliveryClient } from '../../../../lib/connect/clients';
export const contractsClient = createClient(RegistryContractService, connectTransport);
// Use the owning registries' read flows. These results are cached by BOTH
// tenant and viewer in ContractsTab, rather than the older shared hook keys.
export async function loadAssociationOptions(companyId) {
    const [companies, agencies, vehicles] = await Promise.all([
        deliveryClient.listCompanyProfiles({
            companyId
        }),
        deliveryClient.listGovernmentOrganizations({
            companyId,
            includeSystem: true
        }),
        deliveryClient.listContractVehicles({
            companyId
        })
    ]);
    return {
        companies: companies.profiles.map((c)=>({
                id: c.id,
                label: c.name
            })),
        agencies: agencies.organizations.map((a)=>({
                id: a.id,
                label: a.displayPath || a.name
            })),
        vehicles: vehicles.vehicles.map((v)=>({
                id: v.id,
                label: `${v.name} · ${v.vehicleType}`
            })),
        rates: []
    };
}
export async function loadRateOptions(companyId, offset) {
    const page = await deliveryClient.listRateObservations({
        companyId,
        offset,
        limit: 50
    });
    return {
        options: page.observations.map((r)=>({
                id: r.id,
                recordId: r.lcatEntryId,
                label: `${r.lcatTitle || 'Untitled category'} · ${r.companyName || 'Unknown company'} · ${r.vehicleName || 'Unknown vehicle'} · ${r.observationType} · ${r.periodLabel || 'Unknown period'}`
            })),
        nextOffset: page.observations.length === 50 ? offset + 50 : undefined
    };
}
